import { render, staticRenderFns } from "./ParametresDepot.vue?vue&type=template&id=498829fd&scoped=true&"
import script from "./ParametresDepot.vue?vue&type=script&lang=js&"
export * from "./ParametresDepot.vue?vue&type=script&lang=js&"
import style0 from "./ParametresDepot.vue?vue&type=style&index=0&id=498829fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498829fd",
  null
  
)

export default component.exports